import React, { Component } from "react";
import './footer.css';

export default class Footer extends Component {

    public render() {

        return(
            <div id = "footer">
                
                All rights reserved Guy Rozen 2021.

            </div>
        );
    }
}